import { getEnv } from "./env";

/**
 * Fire-and-forget capture to PostHog's event endpoint. The legacy app does
 * not ship posthog-js, so rollout telemetry posts raw events directly.
 */
export const capturePostHogEvent = (
  event: string,
  distinctId: string,
  properties?: Record<string, string>,
) => {
  fetch("https://eu.i.posthog.com/i/v0/e/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    keepalive: true,
    body: JSON.stringify({
      api_key: getEnv().posthogKey,
      event,
      distinct_id: distinctId,
      // Which surface sent it, the property every client's events carry.
      properties: { ...properties, client: "legacy_web" },
    }),
  }).catch(() => undefined);
};
